/* istanbul ignore file */
import { generateStore, withStateHydration } from '@noths/polaris-client-next-redux';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';

import { combinedReducer, ReduxApplicationState } from './combinedReducer';
import { GAMiddleware } from './GAMiddleware';

export const { useStore, getStore } = generateStore<ReduxApplicationState>({
  reducer: withStateHydration<ReduxApplicationState>(combinedReducer),
  middleware: [GAMiddleware],
});

export type AppThunkDispatch = ThunkDispatch<ReduxApplicationState, void, AnyAction>;
